<template>
  <el-container id="resvTxSet">
    <el-header style="height:38px;line-height:30px;padding-left:16px;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} > </p>
        <p style="color:#000000;line-height:0.3;margin-left:5px">{{ h_text }}</p>
      </div>
    </el-header>
    <div style="padding:20px">
      <div style="display: flex;padding-bottom:10px">
        <p style="width:110px">同行人关怀</p>
        <div v-for="(d,index) in liTx"
             style="width:120px;margin-left:5px;display:flex;background: #b3d8ff;justify-content: center;align-items: center">
          <p @click="changeTxTc(d,index)" style="width:90%;text-align:center">{{ d.name }}</p>
          <i @click="delTx(d)" class="el-icon-close"
             style="margin-left:auto;margin-right:5px;margin-top:5px;font-size:20px;"></i>
        </div>
        <el-button @click="addTxTc" type="primary" icon="el-icon-plus" style="margin-left:20px">添加标签
        </el-button>
      </div>
    </div>
    <div style="padding:20px">
      <div style="display: flex;padding-bottom:10px">
        <p style="width:110px">服务内容选择</p>
        <el-upload
            class="upServer"
            ref="upload"
            list-type="picture-card"
            :headers="headerOdj"
            :action="adminUrl"
            :file-list="imgList"
            :before-remove="() => false"
            :before-upload="beforeAvatarUpload"
            :on-success="handlePictureCardPreview"> <!--:on-remove="handleRemove"-->
          <i slot="default" class="el-icon-plus"></i>
          <div slot="file" slot-scope="{ file }">
            <img class="el-upload-list__item-thumbnail"
                 :src="file.url"
                 alt=""/>
            <el-input
                v-model="file.name"
                @change="onName(file, imgList)"
                placeholder="服务名">
            </el-input>
            <span class="el-upload-list__item-actions">
               <span
                   class="el-upload-list__item-preview"
                   @click="checkCardPreview(file)">
                 <i class="el-icon-zoom-in"></i>
               </span>
               <span
                   class="el-upload-list__item-delete"
                   @click="handleRemove(file, imgList)">
                   <i class="el-icon-delete"></i>
               </span>
            </span>
          </div>
        </el-upload>
        <el-dialog
            class="review-dialog"
            append-to-body
            :visible.sync="imgDialogVisible">
          <img width="100%" :src="dialogImageUrl" alt=""/>
        </el-dialog>
      </div>
    </div>
    <el-dialog :title=titles center :close-on-click-modal="false"
               width="15vw" class="dialogApp"
               style="-moz-user-select: none;user-select: none; font-size: inherit;"
               :visible.sync='daiApp'> <!--v-draggable 拖动-->
      <div
          style="display:flex;margin-bottom:20px;width:100%;line-height:0.3;text-align:left;align-items:center;">
        <el-input placeholder="请输入名称" style="width:100%;height:30px;" v-model="edi_name"></el-input>
      </div>
      <div style="display:flex;width:100%;margin-top:10px">
        <el-button type="primary" @click="daiApp=false" style="margin-left:auto;margin-right:5px">取消</el-button>
        <el-button type="primary" @click="addDev" style="margin-left:5px;margin-right:5px">确定</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import axios from "axios";

export default {
  name:"resvTxSet",
  data() {
    return {
      url_upFile:'',
      imgList:[
        // {
        //   id:1,
        // img_id:1,
        //   name:"束带结发抗裂砂浆付了款受打击发撒",
        //   url:this.$urls.ip + "/uploads/file/6ec370a4b5b1ea89aea2110ebdc7f8a1_20251124210315.png"
        // }
      ],
      adminUrl:this.$urls.ip + this.$urls.uploadFile,
      dialogVisible:false,
      imgDialogVisible:false,
      dialogImageUrl:"",
      daiApp:false,
      edi_name:"",
      titles:'添加同行人关怀',
      liTx:[],
      h_text:"空间预约设置",
      li_h_text:[
        {"text":"会所管理","colour":"#B7B7B7","pages":""}
      ],
      headerOdj:{
        'token':localStorage.getItem("token")
      }
    };
  },
  methods:{ /*方法存放*/
    addTxTc() {
      this.edi_name = "";
      this.titles = "添加同行人关怀";
      this.daiApp = true;
    },
    changeTxTc(d,index) {
      this.xz_index = index;
      this.id_tx = d.id;
      this.edi_name = d.name;
      this.titles = "修改同行人关怀信息";
      this.daiApp = true;
    },
    delTx(d) {
      // this.liTx.splice(index,1);
      const params = {
        "id":d.id,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.delAppointCare,params,headers).then(res => {
        console.log("delInterestingDrink:",res.data.data);
        this.$message.success("删除成功");
        this.getInfo();
        this.daiApp = false;
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("删除数据失败");
        }
      });
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    handleRemove1(file,fileList) {
      console.log("##file",file);
      console.log("##fileList",fileList);
      console.log("1111");
      // this.getAppointServiceList()
      return false;
    },
    handleRemove(file,fileList) {
      console.log("##file",file);
      console.log("##fileList",fileList);
      const params = {
        "id":file.id,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.delAppointService,params,headers).then(res => {
        console.log("delAppointService:",res.data.data);
        this.$message.success("删除成功");
        this.getAppointServiceList();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("删除数据失败");
        }
      });
    },
    onName(file,fileList) {
      console.log("##file",file);
      console.log("##fileList",fileList);
      const params = {
        'id':file["id"],
        "name":file['name'],
        'images':[
          {
            "id":file["img_id"],
            "projectId":localStorage.getItem("projectId")
          }
        ],
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.editAppointService,params,headers).then(res => {
        console.log("editAppointService:",res.data.data);
        this.$message.success("修改成功");
        this.getAppointServiceList();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("修改数据失败");
        }
      });
    },
    checkCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.imgDialogVisible = true;
    },
    handlePictureCardPreview(response,file,fileList) {
      if (file != null) {
        // 接口上传 需要formData 文件类型
        let formData = new FormData();
        // "uploadImage" 这个字段需要看后端需提供详细
        formData.append("file",file.raw);
        formData.append('projectId',localStorage.getItem("projectId"));
        // 设置请求头
        const config = {
          headers:{
            'Content-Type':'multipart/form-data', // 注意这里不需要设置Content-Type，因为FormData会自动设置正确类型
            'token':localStorage.getItem("token")
          }
        };
        console.log(this.$urls.ip + this.$urls.uploadFile);
        // 使用axios或其他HTTP客户端发送请求
        axios.post(this.$urls.ip + this.$urls.uploadFile,formData,config) // 替换your-upload-url为你的上传URL
            .then(response => {
              console.log(response.data);
              const id = response.data.data.id;
              const name = response.data.data.name;
              const url = this.$urls.ip + "/" + response.data.data.url;
              this.addAppointService(name,id);
              this.dialogVisible = false;
            }).catch(error => {
          console.log(error);
          if (error) {
            this.$message.error("上传失败");
          }
        });
      }
    },
    getAppointServiceList() {
      const params = {
        "page":1,
        "pageSize":30,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getAppointServiceList,params,headers).then(res => {
        console.log("getAppointServiceList:",res.data.data);
        let l_d = res.data.data.list;
        if (l_d && l_d.length > 0) { /*服务*/
          const l = [];
          for (let i = 0; i < l_d.length; i++) {
            let d = {
              id:l_d[i]['id'],
              name:l_d[i]['name']
            };
            if (l_d[i]['images'] && l_d[i]['images'].length > 0) {
              d['img_id'] = l_d[i]['images'][0]['id'];
              d['url'] = this.$urls.ip + '/' + l_d[i]['images'][0]['url'];
            }
            l.push(d);
          }
          this.imgList = l;
        } else {
          this.imgList = [];
        }
      });
    },
    addAppointService(name,id) {
      const params = {
        "name":name,
        'images':[
          {
            "id":id,
            "projectId":localStorage.getItem("projectId")
          }
        ],
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.newAppointService,params,headers).then(res => {
        console.log("addAppointService:",res.data.data);
        this.$message.success("添加成功");
        this.getAppointServiceList();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("添加数据失败");
        }
      });
    },
    handleAvatarSuccess1(response) {
      console.log(response);
    },
    addDev() {
      const params = {
        "name":this.edi_name,
        'projectId':localStorage.getItem("projectId")
      };
      let tmpUrl = this.$urls.newInterestingProduct;
      if (this.titles === "添加同行人关怀") {
        // this.liTx.push(this.edi_name);
        tmpUrl = this.$urls.newAppointCare;
      } else if (this.titles === "修改同行人关怀信息") {
        // this.liTx[this.xz_index] = this.edi_name;
        params["id"] = this.id_tx;
        tmpUrl = this.$urls.editAppointCare;
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + tmpUrl,params,headers).then(res => {
        console.log("editAppointSetting:",res.data.data);
        this.$message.success("添加成功");
        this.getInfo();
        this.daiApp = false;
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("保存数据失败");
        }
      });
    },
    getInfo() {
      const params = {
        "page":1,
        "pageSize":30,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getAppointCareList,params,headers).then(res => {
        console.log("getInfo:",res.data.data);
        let l_d = res.data.data.list;
        if (l_d && l_d.length > 0) { /*同行*/
          const l = [];
          for (let i = 0; i < l_d.length; i++) {
            l.push({id:l_d[i]['id'],name:l_d[i]['name']});
          }
          this.liTx = l;
        } else {
          this.liTx = [];
        }
      });
    }
  },
  mounted() { /*页面加载时调用*/
    this.getInfo();
    this.getAppointServiceList();
  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style>
#resvTxSet {
  height: 95vh;
  margin: 0;
  padding-top: 0;
  background: #F4F4F4;
}

.el-upload-list {
  .is-success {
    overflow: hidden;
    width: 160px;
    height: 210px;
    border: 0;
    border-radius: 0;
    margin-right: 10px;

    img,
    .el-upload-list__item-actions {
      height: 160px;
    }

    .el-input {
      .el-input__inner {
        height: 40px;
        line-height: 40px;
      }
    }
  }

  .is-ready, .is-uploading {
    display: none;
  }
}

el-upload > .upServer {
  width: 160px;
  height: 160px;
  line-height: 160px;
  background: transparent;
  border: 1px solid #dcdfe6;
  border-radius: 0;
  margin-bottom: 20px;

  .el-icon-plus {
    color: #dcdfe6;
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/hs/resvTxSet.vue